// extracted by mini-css-extract-plugin
module.exports = {"navigation":"VcHeaderNavigation_navigation_1o7iP","link":"VcHeaderNavigation_link_1DeDh","closed":"VcHeaderNavigation_closed_ayLz_"};